import React from "react";
import { Form } from "antd";
import { StepPanel } from "./step_panal/StepPanal";
import DetailPointForm from "./detail_point_form/DetailPointForm";
import SJDetailFrom from "./sj_detail_form/SJDetailFrom";
import FiberOpticForm from "./fiber_optic_form/FiberOpticForm";
import { defaultFormButtonLayout } from "../../utility/form_layout";

export default function RepairingPoint() {
  const steps = [
    {
      title: "บันทึกงาน",
      description: "บันทึกรายละเอียดงาน",
      content: <DetailPointForm title="บันทึกงานที่ต้นทาง"></DetailPointForm>,
    },
    {
      title: "บันทึกข้อมูล SJ",
      description: "บันทึกรายละเอียดข้อมูล SJ",
      content: <SJDetailFrom title="บันทึกข้อมูล SJ"></SJDetailFrom>,
    },
    {
      title: "บันทึกสาย Fiber Optic",
      description: "บันทึกรายละเอียดข้อมูลสาย Fiber Optic",
      content: <FiberOpticForm title="บันทึกสาย Fiber Optic"></FiberOpticForm>,
    },
  ];
  const [form] = Form.useForm();
  const onSubmit = () => {
    const formData = form.getFieldsValue();

    // POST the data to backend and show Notification
    console.log(formData);
  };
  return (
    <div className="bbtec-theme">
      <Form
        layout="vertical"
        {...defaultFormButtonLayout}
        onFinish={onSubmit}
        form={form}
      >
        <StepPanel steps={steps}></StepPanel>
      </Form>
    </div>
  );
}
